
// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the
// presence of a DOM element with a given data attribute.

// This file is loaded globally but should just contain dynamically
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// --------------------------------

if (true) {
	import('./main')
	.then(({ mainJs }) => {
		mainJs()
	})
}

// --------------------------------
// Fade in and up animation when in viewport
// --------------------------------
const fadeInUpElements = document.querySelectorAll('[data-animation="fadeInUp"]')
console.log(fadeInUpElements)
console.log('test')
if (fadeInUpElements.length > 0) {
  import('./animation/fade-in-up')
    .then(({ fadeInUp }) => {
			fadeInUpElements.forEach(element => {
				fadeInUp(element)
			})
		})
}

// --------------------------------
// Animate cards on scroll within a grid
// --------------------------------
const grids = document.querySelectorAll('[data-animation="grid-cards"]')

if (grids.length > 0) {
  import('./animation/grid-cards')
    .then(({ gridCards }) => {
			grids.forEach(grid => {
				gridCards(grid)
			})
		})
}

// --------------------------------
// Animate cloud on scroll
// --------------------------------
const clouds = document.querySelectorAll('[data-module="cloud"]')

if (clouds.length > 0) {
  import('./animation/cloud')
    .then(({ cloudAnimation }) => {
			clouds.forEach((cloud, i) => {
				cloudAnimation(cloud, i)
			})
		})
}

// --------------------------------
// Auto play videos when they are in the viewport
// --------------------------------
const videos = document.querySelectorAll('[data-module="autoplay-video"]')

if (videos.length > 0) {
  import('./components/video-observer')
    .then(({ videoObserver }) => {
			videos.forEach(video => {
				videoObserver(video)
			})
		})
}

// --------------------------------
// Animate curves in viewport
// --------------------------------
const curves = document.querySelectorAll('[data-module="curve"]')

if (curves.length > 0) {
  import('./components/curve')
    .then(({ curveAnimation }) => {
			curves.forEach(curve => {
				curveAnimation(curve)
			})
		})
}

// --------------------------------
// Careers interaction
// --------------------------------
const careersSections = document.querySelectorAll('[data-module="careers-section"]')

if (careersSections.length > 0) {
  import('./components/career')
    .then(({ career }) => {
      careersSections.forEach(section => {
        career(section)
      })
    })
}

// --------------------------------
// Career Split
// --------------------------------
const careerSplits = document.querySelectorAll('[data-module="career-split"]')

if (careerSplits.length > 0) {
	import('./components/career-split')
			.then(({ careerSplit }) => {
				careerSplits.forEach(section => {
					careerSplit(section)
				})
			})
}


// --------------------------------
// Full width carousel
// --------------------------------
const fullWidthCarousels = document.querySelectorAll('[data-module="full-width-carousel"]')

if (fullWidthCarousels.length > 0) {
	import('./components/full-width-carousel')
			.then(({ fullWidthCarousel }) => {
				fullWidthCarousels.forEach(section => {
					fullWidthCarousel(section)
				})
			})
}

// --------------------------------
// Home hero interaction
// --------------------------------
const homeHeros = document.querySelectorAll('[data-module="home-hero"]')

if (homeHeros.length > 0) {
  import('./components/home-hero')
    .then(({ homeHero }) => {
			homeHeros.forEach(hero => {
				homeHero(hero)
			})
		})
}

// --------------------------------
// Home heros
// --------------------------------
const heros = document.querySelectorAll('[data-module="home-heros"]')

if (heros.length > 0) {
  import('./components/home-heros')
    .then(({ homeHeros }) => {
			heros.forEach(hero => {
				homeHeros(hero)
			})
		})
}


// --------------------------------
// Home about pinning
// --------------------------------
const homeAbout = document.querySelectorAll('[data-module="pin-about"]')

if (homeAbout.length > 0) {
  import('./components/pin-about')
    .then(({ pinAbout }) => {
			homeAbout.forEach(about => {
				pinAbout(about)
			})
		})
}

// --------------------------------
// Team carousel
// --------------------------------
const teamCarousels = document.querySelectorAll('[data-module="team-carousel"]')

if (teamCarousels.length > 0) {
  import('./components/team-carousel')
    .then(({ teamCarousel }) => {
      teamCarousels.forEach(parentSection => {
        teamCarousel(parentSection)
      })
    })
}

// --------------------------------
// Work carousel
// --------------------------------
const workCarousels = document.querySelectorAll('[data-module="work-carousel"]')

if (workCarousels.length > 0) {
  import('./components/work-carousel')
    .then(({ workCarousel }) => {
			workCarousels.forEach(parentSection => {
				workCarousel(parentSection)
			})
		})
}

// --------------------------------
// Values carousel
// --------------------------------
const valuesCarousels = document.querySelectorAll('[data-module="values-carousel"]')

if (valuesCarousels.length > 0) {
  import('./components/values-carousel')
    .then(({ valuesCarousel }) => {
			valuesCarousels.forEach(carousel => {
				valuesCarousel(carousel)
			})
		})
}

// --------------------------------
// Future events carousel
// --------------------------------
const futureEventsCarousels = document.querySelectorAll('[data-module="future-events-carousel"]')

if (futureEventsCarousels.length > 0) {
  import('./components/future-events-carousel')
    .then(({ eventsCarousel }) => {
			futureEventsCarousels.forEach(carousel => {
				eventsCarousel(carousel)
			})
		})
}

// --------------------------------
// Load more posts
// --------------------------------
const loadMoreButtons = document.querySelectorAll('[data-module="load-more"]')

if (loadMoreButtons.length > 0) {
  import('./components/load-more')
    .then(({ loadMore }) => {
			loadMoreButtons.forEach(button => {
				loadMore(button)
			})
		})
}

// --------------------------------
// Video lightboxes
// --------------------------------
const lightboxButtons = document.querySelectorAll('[data-module="video-lightbox"]')

if (lightboxButtons.length > 0) {
  import('./components/video-lightbox')
    .then(({ videoLightbox }) => {
			lightboxButtons.forEach(button => {
				videoLightbox(button)
			})
		})
}

// --------------------------------
// Diversity animation / scroll lock
// --------------------------------
const diversityContainer = document.querySelectorAll('[data-module="diversity"]')

if (diversityContainer.length > 0) {
  import('./components/diversity')
    .then(({ diversity }) => {
			diversityContainer.forEach(container => {
				diversity(container)
			})
		})
}

// --------------------------------
// Perks animation
// --------------------------------
const perksContainer = document.querySelectorAll('[data-module="perks"]')

if (perksContainer.length > 0) {
  import('./components/perks')
    .then(({ perks }) => {
			perksContainer.forEach(container => {
				perks(container)
			})
		})
}


// --------------------------------
// Filtering
// --------------------------------
const filtersContainers = document.querySelectorAll('[data-module="filters"]')

if (filtersContainers.length > 0) {
  import('./components/filters')
    .then(({ filters }) => {
			filtersContainers.forEach(container => {
				filters(container)
			})
		})
}


// --------------------------------
// Scroll to a target (with smooth scroll)
// --------------------------------
const scrollToTriggers = document.querySelectorAll('[data-module="scroll-to"]')

if (scrollToTriggers.length > 0) {
  import('./components/scroll-to')
    .then(({ scrollTo }) => {
			scrollToTriggers.forEach(trigger => {
				scrollTo(trigger)
			})
		})
}

// --------------------------------
// Google maps
// --------------------------------
const maps = document.querySelectorAll('[data-module="map"]')

if (maps.length > 0) {
  import('./components/map')
    .then(({ map }) => {
			maps.forEach(mapEl => {
				map(mapEl)
			})
		})
}

// --------------------------------
// Bamboo HR
// --------------------------------
const bambooHrEmbeds = document.querySelectorAll('[data-module="bamboo-hr"]')

if (bambooHrEmbeds.length > 0) {
  import('./components/bamboo-hr')
    .then(({ bambooHr }) => {
			bambooHrEmbeds.forEach(embed => {
				bambooHr(embed)
			})
		})
}
